import { v4 as uuidv4 } from "uuid";
export class ServiceModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.latestVersion = null;
        this.description = null;
        this.url = null;
    }
}
export default class Service extends ServiceModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
